"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SaxDocument_1 = require("../SAXImpl/SaxDocument");
var XmlDocument = /** @class */ (function () {
    /**
     *
     */
    function XmlDocument() {
    }
    XmlDocument.getInstance = function () {
        return new SaxDocument_1.default();
        //return new DotNetJSONDocument();
    };
    XmlDocument.prototype.Deserialize = function (context, sPath, Source, useTranslation) {
        throw new Error("Method not implemented.");
    };
    XmlDocument.prototype.getRootNode = function () {
        throw new Error("Method not implemented.");
    };
    XmlDocument.prototype.createNode = function (node, strName) {
        throw new Error("Method not implemented.");
    };
    return XmlDocument;
}());
exports.default = XmlDocument;

//# sourceMappingURL=XmlDocument.js.map
